export default {"src":"/_next/static/media/icon-guide.da8f9b18.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};